const productFieldsEssentials =
    'pk,code,url,name,icons,crossSellingProducts,similarProducts,allowedLotSize,sizeInBaseUnits,myAssortment,frozenProduct,favorite,novelty,seasonal,sponsored,' +
    'campaign,unit,summary,categories(FULL,level),comparisonPrice(DEFAULT),comparisonUnit(FULL),ean,lotSizeInfo,inOrderTemplate,' +
    'baseUnit(FULL),discount(DEFAULT),strikeThroughPrice(DEFAULT),price(DEFAULT),priceWithTax(DEFAULT),taxPercentage,taxPercentageCatalogPrice,images(FULL),' +
    'stock(FULL),purchasable,pikatukkuWebShopProduct,availabilityNotificationActive,solrDebugInfo,pikatukkuStock(FULL)';
const productFieldsListing =
    'pk,code,url,name,icons,crossSellingProducts,similarProducts,allowedLotSize,sizeInBaseUnits,myAssortment,frozenProduct,favorite,novelty,seasonal,sponsored,' +
    'campaign,unit,summary,comparisonPrice(DEFAULT),comparisonUnit(FULL),lotSizeInfo,inOrderTemplate,' +
    'baseUnit(FULL),discount(DEFAULT),strikeThroughPrice(DEFAULT),price(DEFAULT),priceWithTax(DEFAULT),taxPercentage,taxPercentageCatalogPrice,images(FULL),' +
    'stock(FULL),purchasable,pikatukkuWebShopProduct,availabilityNotificationActive,solrDebugInfo,pikatukkuStock(FULL)' +
    'classifications(code,features(name, code,featureValues(name))),lastPurchased';
const productFieldsFull =
    productFieldsEssentials +
    ',nutritionalContentBasisQuantity,nutritionalContentBasisQuantityUnit(FULL),manualKeyIngredients,' +
    'keyIngredients,description,unitConversions(FULL),tags,classifications(FULL),vendor(FULL),countriesOfOrigin(FULL),' +
    'lastPurchased,preparationInstructions,usageInstructions,fishingInformation(FULL),ingredients(FULL),safetyData(sheetId),storageInstructions,' +
    'disposalInformations,availabilityNotificationActive,productReferences(preselected,referenceType,target(' +
    productFieldsEssentials +
    '),quantity)';

export const aimoOccProductConfig = {
    backend: {
        occ: {
            endpoints: {
                product: {
                    default: 'products/${productCode}?fields=' + productFieldsFull,
                    list: 'products/${productCode}?fields=' + productFieldsListing,
                    details: 'products/${productCode}?fields=' + productFieldsFull,
                },
                loadMany: 'products/loadMany?fields=' + productFieldsListing,
                excelExportProducts: 'products/excelExport?spinner=true',
                safetyDataExport: 'products/safetyDataExport/${code}?spinner=true',
                productSearch:
                    'products/search?fields=products(' +
                    productFieldsListing +
                    '),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery,suggestiveMode,keywordRedirectUrl,categorySuggestions(FULL)',
                productSuggestions: 'products/suggestions',
                toggleAvailabilityNotification: 'products/stockNotification/${productCode}',
            },
        },
        loadingScopes: {
            product: {
                details: {
                    include: ['list', 'variants'],
                },
            },
        },
    },
};
